import React, { ReactNode } from "react";
import { createStyles, makeStyles } from "@material-ui/core";
import { Footer } from "./Footer";
import { connect } from "react-redux";

const useStyles = makeStyles(({ breakpoints }) => {
  return createStyles({
    root: {
      minHeight: "100vh",
      zIndex: 1,
      overflow: "hidden",
      position: "relative",
      width: "100%",
      backgroundColor: "#f3f3f3",
      paddingTop: 10
    },
    contentContainer: {
      width: 394,
      [breakpoints.down("sm")]: {
        marginLeft: 10,
        marginRight: 10,
        width: "auto"
      },
      marginLeft: "auto",
      marginRight: "auto"
      // boxShadow: "0 12px 44px 0 rgba(0, 0, 0, 0.1)"
    }
  });
});

interface IProps {
  env: any;
  children: ReactNode;
}

const LayoutWithFooterControl = (props: IProps) => {
  const { children } = props;
  const classes = useStyles({});
  return (
    <div className={classes.root}>
      <div className={classes.contentContainer}>
        {children}
        <Footer region={props.env.REGION}/>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    env: state.env
  };
};

export const LayoutWithFooter = connect(
  mapStateToProps,
  null)(LayoutWithFooterControl);

